import {defineStore} from 'pinia'
import {http} from '@/extensions/http/index.js'
import {API_ENDPOINTS} from '@/config/index.js'

export const useAlertStore = defineStore('alert', {
    state: () => {
        return {
            data: null
        }
    },
    actions: {
        async init() {
            try {
                const {data} = await http.get(API_ENDPOINTS.ALERT.INDEX)

                this.data = data[0]
            } catch { /**/ }
        },
        async update(id, payload) {
            try {
                const {data} = await http.put(API_ENDPOINTS.ALERT.UPDATE.replace(':id', id), payload)

                this.data = data
            } catch { /**/ }
        }
    }
})